import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing12,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { ComponentDisplayDetails } from './component-parts.style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import {
  grey1,
  grey4,
  grey5,
  grey9,
} from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { TooltipWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { PAGE_CONTROL_HEIGHT } from '../slideshow/slideshow-view.style';

export const PagesPreview = styled.div`
  ${ComponentDisplayDetails} {
    border: none;
  }
`;

type PagesPreviewWrapperProps = {
  hasCaption?: boolean;
};
export const PagesPreviewWrapper = styled.div<PagesPreviewWrapperProps>`
  position: relative;

  ${TooltipWrapperStyled} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  ${({ hasCaption }) =>
    hasCaption &&
    `
    ${PagesPreviewView} {
      bottom: ${rem(120)};
    }
  `}
`;

export const PagesActions = styled.div`
  ${flexCentreAlignCss}
  gap: ${rem(spacing12)};
  position: absolute;
  top: ${rem(spacing24)};
  right: ${rem(spacing24)};
  z-index: 1;
`;

export const PagesPreviewView = styled.div`
  border-radius: ${rem(borderRadius8)};
`;

export const PagesPreviewModal = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

type PagesPreviewModalInnerProps = {
  $hasCaption: boolean;
};
export const PagesPreviewModalInner = styled.div<PagesPreviewModalInnerProps>`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rem(spacing40)};
  ${({ $hasCaption }) =>
    $hasCaption &&
    `
      padding-bottom: 0;
  `}
  position: relative;
  transition: all 300ms ease;
`;

type PagesPreviewImageProps = {
  isLoading: boolean;
};

export const PagesPreviewImage = styled.div<PagesPreviewImageProps>`
  ${flexCentreAlignCss}

  background-color: transparent;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  img {
    background-color: ${grey1};
    ${({ isLoading }) =>
      !isLoading
        ? `
    opacity: 1;
    visibility: visible;
    transition: opacity 600ms ease, visibility 0ms linear;
  `
        : `
    opacity: 0;
    visibility: hidden;
    transition: opacity 0s ease, visibility 0s ease;
  `}
  }
`;

export const PagesPreviewImageButton = styled.button`
  background-color: transparent;
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  ${standardFocusState}

  &:hover {
    border: 1px solid ${grey9};
    cursor: pointer;
  }
`;

export const PagesPreviewContainer = styled.div`
  background-color: ${grey1};
  position: relative;
  width: 100%;
  height: calc(100% - ${rem(spacing40)});

  ${ComponentDisplayDetails} {
    border: none;
  }

  ${PagesPreviewWrapper} {
    height: 100%;
  }

  ${PagesPreviewView} {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

export const PagesPreviewEditContainer = styled(PagesPreviewContainer)`
  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  height: 100%;

  ${PagesPreviewWrapper} {
    height: calc(100% - ${rem(PAGE_CONTROL_HEIGHT)});
  }
`;

export const PagesPreviewLoading = styled.div`
  ${flexCentreAlignCss}
  height: 100%;
`;

export const PagesPreviewPageControls = styled.div`
  ${flexCentreAlignCss}
  ${font16}

  background-color: ${grey1};
  height: ${rem(PAGE_CONTROL_HEIGHT)};
`;
